<div class="main-content" #editRow>
	<div class="card tp-box m-0 p-0">
		<div class="card-header card-header-{{config.color}}-5"> COUNTER POS RECEIPT</div>
		<div class="card-body">
				<!-- <iframe id="ifrm" style="width: 100%; height: 100%;"></iframe> -->
				<ng-container *ngIf="receipt_data">
					<div class="row m-0 p-0s">

						<div class="col-12 ml-auto mr-auto text-center">
							<h1 class="text-success">SUCCESS</h1>
							<h4 class="bold">{{ (config.documentlabel ? config.documentlabel : "DOCUMENT") | uppercase }}#: {{ receipt_data.transno }}</h4>
							<h4 class="bold">{{ (config.orderlabel ? config.orderlabel : "INVOICE") | uppercase }}#: {{ receipt_data.orderno }}</h4>
							<h4 class="bold">CUSTOMER#: {{ receipt_data.header.debtorno }}.{{ receipt_data.header.branchcode }}</h4>
							<h4 class="bold">CUSTOMER: {{ receipt_data.header.deliverto }}</h4>
							<h4 class="bold" *ngIf="receipt_data.header?.customerref">CUSTOMER PO#: {{ receipt_data.header.customerref }}</h4>
						</div>
						<div class="col-12 ml-auto mr-auto  text-center">
							<div class="circle-loader load-complete">
								<div class="checkmark-complete draw checkmark"></div>
							</div>
						</div>
						<div class="col-md-4 ml-0 mr-auto  text-center">
							<a mat-flat-button color="accent" class="bg-accent fullsize" (click)="sendPrint()"><div class="pt-4 mt-2">RE-PRINT</div></a>
						</div>
						<div class="col-md-4 ml-auto mr-auto  text-center">
							<a mat-flat-button color="primary" class="bg-primary fullsize" href="{{receipt_data.link}}" ><div class="pt-4 mt-2">DOWNLOAD</div></a>
						</div>

						<div class="col-md-4 text-center ml-auto mr-0  text-center ">
							<button mat-flat-button color="danger" class="bg-danger text-white fullsize m-0 p-0" (click)="$event.preventDefault();newOrder()">NEW ORDER</button>
						</div>


						<div class="col-md-4 ml-0 mr-auto">
							&nbsp;&nbsp;
						</div>

						<div class="col-md-4 mt-3 ml-0 mr-auto text-center">
							<!-- EMAIL Button -->
							<button
								mat-flat-button
								color="success"
								class="bg-success text-white fullsize ml-auto mr-auto p-0"
								(click)="$event.preventDefault(); emailReceipt()"
							>
								EMAIL
							</button>

							<!-- Email Form -->
							<div class="email-entry-card mt-3 px-3 py-2">
								<div class="row no-gutters align-items-center">
								  <!-- Email Textarea -->
								  <div class="col-md-6 pr-1">
									<label class="form-label" for="emailCsv">Emails <small>(e.g. john@example.com, jane@site.com)</small></label>
									<textarea
									  id="emailCsv"
									  class="form-control styled-input thin-input"
									  [formControl]="email"
									  placeholder="email1@example.com, email2@example.com"
									  rows="2"
									></textarea>
								  </div>

								  <!-- Type Select -->
								  <div class="col-md-3 pr-1 pl-1">
									<label class="form-label" for="emailType">Document<br>Type</label>
									<select
									  id="emailType"
									  class="form-control styled-input thin-input"
									  [formControl]="emailopt"
									>
									  <option value="invoice">Invoice</option>
									  <option value="receipt">Receipt</option>
									  <option value="both">Both</option>
									</select>
								  </div>

								  <!-- Save Checkbox -->
								  <div class="col-md-3 pl-1 d-flex align-items-start mt-3 mt-md-0">
									<label class="custom-checkbox-container mb-0 mt-3">
									  <input type="checkbox" [(ngModel)]="saveEmail" />
									  <span class="custom-checkmark"></span>
									  <span class="check-label ml-0">Save emails?</span>
									</label>
								  </div>
								</div>

								<!-- Parsed Emails -->
								<div class="row mt-3" *ngIf="parsedEmails.length">
								  <div class="col-12 d-flex flex-wrap align-items-center">
									<small class="text-muted mr-2">Emails:</small>
									<span
									  class="parsed-email-chip"
									  *ngFor="let e of parsedEmails"
									>{{ e }}</span>
								  </div>
								</div>
							  </div>


						</div>






						<div class="col-md-4 ml-auto mt-3 mr-0">
							&nbsp;&nbsp;
						</div>
						<div class="col-md-12 m-0 p-0 text-center bg-white">

							<!-- <iframe #pdfFrame id="pdfFrame" style="display: block;"></iframe> -->
							<!-- <ngx-extended-pdf-viewer [base64Src]="receipt_data.print" useBrowserLocale="true" [handTool]="false" [textLayer]="true" [showOpenFileButton]="false" [showPropertiesButton]="false" [showHandToolButton]="true" [filenameForDownload]="receipt_data.title"></ngx-extended-pdf-viewer> -->


							<div class="ml-auto mr-auto m-0 p-0 rec ml-auto mr-auto  text-center">
								<app-pos-viewer [htmlContent]="recDisplay" class="ml-auto mr-auto m-0 p-0 rec ml-auto mr-auto  text-center"></app-pos-viewer>
								<!-- <div [innerHTML]="recDisplay"></div> -->
							</div>
						</div>
					</div>
				</ng-container>
		</div>
	</div>
</div>
